import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  defaultChecked?: boolean;
  disabled?: boolean;
  small?: boolean;
}

function Switch(props: SwitchProps) {
  const { onChange, checked: customChecked, small, ...others } = props;
  const [checked, setChecked] = useState<boolean>(false);
  const inputEl = useRef<any>(null);
  const isControlled = 'checked' in props;

  const SwitchCls = clsx({
    'c-toggle': true,
    'c-toggle--small': small,
  });

  useEffect(() => {
    if (isControlled && customChecked !== checked) {
      setChecked(customChecked);
    }
  }, [customChecked]);

  useEffect(() => {
    if (!isControlled && 'defaultChecked' in others) {
      setChecked(others.defaultChecked!);
    }
  }, [others.defaultChecked]);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (e.target !== inputEl.current) {
      return;
    }

    if (!isControlled) {
      setChecked(!checked);
    }

    if (typeof onChange === 'function') {
      onChange(!checked);
    }
  };

  return (
    <label className={SwitchCls} onClick={handleClick}>
      <input
        type="checkbox"
        checked={isControlled ? checked : undefined}
        ref={inputEl}
        onChange={() => {}}
        {...others}
      />
      <span className="c-toggle__control"></span>
    </label>
  );
}

export { Switch };
